import { render } from "./HeroiconsSolidUserCircle.vue?vue&type=template&id=2026af98"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUserCircle.vue"]])

export default __exports__